module.exports = __webpack_public_path__ + "static/img/6.c74fc81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.png
// module id = 0DhX
// module chunks = 1